export default {
  existing_documents: {
    description:
      'Du hast bereits folgende Dokumente hochgeladen. Wähle eines aus und drücke auf Senden, oder lade stattdessen ein neues Dokument hoch.',
    sides: {
      front: 'Vorderseite',
      back: 'Rückseite',
    },
    created_at: 'Hochgeladen: {{date}}',
    expires_at: 'Gültig bis: {{date}}',
  },
  document_types: {
    owner_document: 'Ausweisdokument des Inhabers',
    business_document: 'Geschäftsdokument',
  },
  form: {
    document_type: {
      label: 'Identitätsnachweisdokument',
      placeholder: 'Dokumenttyp auswählen',
      options: {
        passport: 'Reisepass',
        driver_license: 'Führerschein',
        id_card: 'Personalausweis',
        residence_permit: 'Aufenthaltstitel',
      },
    },
    front: {
      label: 'Dokumentenvorderseite',
    },
    back: {
      label: 'Rückseite des Dokuments (optional für einige Dokumente)',
    },
    expires_at: {
      label: 'Ablaufdatum des Dokuments',
      placeholder: 'Ablaufdatum auswählen',
    },
  },
  buttons: {
    select_file: 'Dokument auswählen',
    next: 'Weiter',
    back: 'Zurück',
    send: 'Senden',
    upload_new: 'Neues Dokument hochladen',
    use_existing: 'Hochgeladenes Dokument verwenden',
  },
};
